import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-user-inactive-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-inactive-modal.component.html',
  styleUrl: './user-inactive-modal.component.scss',
})
export class UserInactiveModalComponent {
  readonly visible = input(false);
  readonly tenantName = input<string | null>(null);
  readonly tenantEmail = input<string | null>(null);
  readonly dismissed = output<void>();

  readonly displayTenant = computed(() => {
    const name = (this.tenantName() ?? '').trim();
    return name ? name : 'this store';
  });

  mailtoHref(): string {
    const raw = (this.tenantEmail() ?? '').trim();
    return `mailto:${encodeURIComponent(raw)}?subject=${encodeURIComponent('Access disabled')}`;
  }
}

